/** Zaokruživanje iznosa po retku zna odstupiti par centi — toliko toleriramo pri provjeri zbroja. */
export const AMOUNT_TOLERANCE = 0.01;

/** Šifrarnik jedinica mjere se rijetko mijenja — dovoljno je jednom u pola sata. */
export const UNITS_CACHE_TTL = 30 * 60 * 1000;

/** Jedinica kad je stavka nema — u praksi su to komadi. */
export const DEFAULT_UNIT_SYMBOL = "kom";

/** Širina stupca s prekidačem Vozilo/Tvrtka — ista u traci i u retku stavke. */
export const TARGET_SWITCH_WIDTH = "w-[150px]";
